/**
 * Text content extraction and validation utilities
 * 
 * This module provides utilities for:
 * - Extracting text content from HTML strings
 * - Validating content emptiness
 * - Checking white spaces in text
 */

import {sanitizeHTML} from './constants';
import {EMPTY_PARAGRAPH} from '../../hooks/useParagraphEditor';

export function getTextContent(html: string): string {
    if(!html) return '';
    
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = sanitizeHTML(html);
    return tempDiv.textContent || '';
}

export function isContentEmpty(content: string): boolean {
    const textContent = getTextContent(content);
    return textContent.trim() === '' || textContent.trim() === EMPTY_PARAGRAPH;
}

export function endsWithWhitespace(text: string): boolean {
    return /\s$/.test(text);
}

export function startsWithWhitespace(text: string): boolean {
    return /^\s/.test(text);
}

export function getTextBeforeRange(element: HTMLElement, range: Range): string {
    if(!element || !range) return '';
    
    if(range.startContainer.nodeType === Node.TEXT_NODE && element.contains(range.startContainer)) {
        return range.startContainer.textContent?.substring(0, range.startOffset) || '';
    }
    
    const beforeRange = document.createRange();
    beforeRange.selectNodeContents(element);
    beforeRange.setEnd(range.startContainer, range.startOffset);
    return beforeRange.toString();
}
